import { crudRequest } from '@/services/api';

const params = {}
export default {
    namespace: 'carrouteline',
    state: {
        detailCenter: '',
        deliveryReceiptNo: '',
        onSearch: false,
        centerFilter: ''
    },

    effects: {
    },

    reducers: {
        updateState(state, { payload }) {
            return { ...state, ...payload };
        },
    }
}
